<template>
  <slot :products="products" />
</template>

<script>
import featuredCollectionQuery from "@/graphql/queries/FeaturedCollection.gql";
import { unwrapNodes } from "@/helpers/graphql";
import { PER_PAGE } from "@/helpers/pagination";

export default {
  name: "CollectionCarouselHelper",
  props: {
    collectionHandle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      products: [],
    };
  },
  apollo: {
    products: {
      query: featuredCollectionQuery,
      skip() {
        return !this.collectionHandle;
      },
      variables() {
        return {
          collection: this.collectionHandle,
          first: PER_PAGE,
        };
      },
      update({ collection }) {
        return unwrapNodes(collection.products?.edges);
      },
    },
  },
};
</script>
